<template>
  <b-card>
    <b-row>
      <b-col md="12" class="d-flex justify-content-between align-items-center">
        <b-form-group label="Screen Type">
          <b-form-radio-group v-model="screenType" :options="screenOptions" />
        </b-form-group>
        <b-button :disabled="submitting" variant="primary" @click="submitForm">
          <b-spinner v-if="submitting" small />
          <span v-else>Submit Ad</span>
        </b-button>
      </b-col>
      <b-col md="4">
        <b-form-group label="Attachment">
          <FileUpload
            ref="fileUploadRef"
            :allow-videos-extension="screenType != SCREEN_TYPES.search"
            @file-uploaded="adForm.key = $event"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="Rank">
          <b-form-input
            v-model.number="adForm.rank"
            type="number"
            min="0"
            placeholder="Enter rank"
          />
        </b-form-group>
      </b-col>
      <template v-if="screenType !== SCREEN_TYPES.search">
        <b-col md="4">
          <b-form-group label="Title En">
            <b-form-input
              v-model="adForm.title_en"
              placeholder="Enter title en"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Title Ar">
            <b-form-input
              v-model="adForm.title_ar"
              placeholder="Enter title ar"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Description En">
            <b-form-textarea
              v-model="adForm.description_en"
              placeholder="Enter description en"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Description Ar">
            <b-form-textarea
              v-model="adForm.description_ar"
              placeholder="Enter description ar"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" class="d-flex justify-content-around align-items-center">
          <b-form-group label="Show Ad Label">
            <b-form-checkbox v-model="adForm.showAdLabel" switch />
          </b-form-group>
          <b-form-group label="Is Actionable">
            <b-form-checkbox v-model="adForm.isActionable" switch />
          </b-form-group>
        </b-col>
        <template v-if="adForm.isActionable">
          <b-col md="3">
            <b-form-group label="Cta Type">
              <b-form-radio-group
                v-model="adForm.ctaType"
                :options="ctaTypes"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Cta Title En">
              <b-form-input
                v-model="adForm.ctaTitle_en"
                placeholder="Enter cta title en"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Cta Title Ar">
              <b-form-input
                v-model="adForm.ctaTitle_ar"
                placeholder="Enter cta title ar"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Cta value">
              <b-input-group>
                <b-input-group-text v-if="adForm.ctaType === CTA_TYPES.url">
                  https://
                </b-input-group-text>
                <b-form-input
                  v-model="adForm.ctaValue"
                  placeholder="Enter value"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </template>
      </template>
      <b-col md="12">
        <b-row>
          <b-col md="12">
            <b-form-group label="Is Default">
              <b-form-checkbox switch v-model="adForm.isDefault" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Start Date">
              <b-form-datepicker
                v-model="adForm.startDate"
                placeholder="Select start date"
                locale="en"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Start Time">
              <b-form-timepicker
                v-model="adForm.startTime"
                placeholder="Select start time"
                locale="en"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="End Date">
              <b-form-datepicker
                v-model="adForm.endDate"
                placeholder="Select end date"
                locale="en"
                :min="today"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="End Time">
              <b-form-timepicker
                v-model="adForm.endTime"
                placeholder="Select end time"
                locale="en"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BFormRadioGroup,
  BFormGroup,
  BRow,
  BCol,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BButton,
  BSpinner,
  BInputGroup,
  BInputGroupText,
  BFormDatepicker,
  BFormTimepicker,
} from "bootstrap-vue";
import { ref, watch } from "@vue/composition-api";
import useRegisterStoreModule from "@/hooks/useRegisterStoreModule";
import store from "../store";
import FileUpload from "./FileUpload.vue";
import {
  errorNotification,
  successNotification,
} from "@/utils/toast-notifications";

export default {
  components: {
    BCard,
    BFormRadioGroup,
    BFormGroup,
    BFormInput,
    FileUpload,
    BFormTextarea,
    BRow,
    BCol,
    BFormCheckbox,
    BSpinner,
    BButton,
    BInputGroup,
    BInputGroupText,
    BFormDatepicker,
    BFormTimepicker,
  },
  setup(_, ctx) {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const userCountry = userData?.country || "JO";
    const INITIAL_AD_DATA = {
      ctaTitle_ar: "",
      description_en: "",
      isActionable: false,
      description: "",
      ctaTitle_en: "",
      title: "",
      key: "",
      title_ar: "",
      ctaType: "",
      showAdLabel: false,
      ctaTitle: "",
      ctaValue: "",
      title_en: "",
      description_ar: "",
      isDefault: false,
      startDate: "",
      startTime: "",
      endDate: "",
      endTime: "",
      rank: 0,
    };
    const SCREEN_TYPES = {
      search: "search",
      lookingForDriver: "looking_for_driver",
      inProgress: "trip_in_progress",
      acceptedTrip: "accepted_trip",
      arrivedTrip: "arrived_trip",
      startedTrip: "started_trip",
    };

    const CTA_TYPES = {
      url: "url",
      call: "call",
    };

    useRegisterStoreModule("ads", store);

    const screenOptions = [
      {
        text: "Search",
        value: SCREEN_TYPES.search,
      },
      {
        text: "Looking for driver",
        value: SCREEN_TYPES.lookingForDriver,
      },
      {
        text: "In progress",
        value: SCREEN_TYPES.inProgress,
      },
      {
        text: "Accepted Trip",
        value: SCREEN_TYPES.acceptedTrip,
      },
      {
        text: "Arrived Trip",
        value: SCREEN_TYPES.arrivedTrip,
      },
      {
        text: "Started Trip",
        value: SCREEN_TYPES.startedTrip,
      },
    ];

    const ctaTypes = [
      {
        text: "Url",
        value: CTA_TYPES.url,
      },
      {
        text: "Call",
        value: CTA_TYPES.call,
      },
    ];

    const screenType = ref("search");

    const adForm = ref(JSON.parse(JSON.stringify(INITIAL_AD_DATA)));

    // Get today's date in YYYY-MM-DD format for date picker minimum
    const today = new Date().toISOString().split("T")[0];

    watch(screenType, () => {
      ctx.refs.fileUploadRef.resetFile();
      Object.assign(adForm.value, INITIAL_AD_DATA);
    });

    watch(
      () => adForm.value.isActionable,
      (newVal) => {
        if (!newVal) {
          adForm.value.ctaTitle_ar = "";
          adForm.value.ctaTitle_en = "";
          adForm.value.ctaType = "";
          adForm.value.ctaValue = "";
        }
      }
    );

    const submitting = ref(false);
    const submitForm = async () => {
      if (!adForm.value.key) {
        errorNotification("You must provide an attachement");
        return;
      }

      // Validate end date/time is in the future
      if (adForm.value.endDate && adForm.value.endTime) {
        const endDateTime = new Date(
          `${adForm.value.endDate}T${adForm.value.endTime}`
        );
        const now = new Date();
        
        if (endDateTime <= now) {
          errorNotification("End date and time must be in the future");
          return;
        }
      }

      try {
        submitting.value = true;
        const payload = {
          country: userCountry,
          screen: screenType.value,
          advertisement: {
            key: adForm.value.key,
            rank: adForm.value.rank,
          },
        };

        if (screenType.value !== SCREEN_TYPES.search) {
          Object.assign(payload.advertisement, {
            ...adForm.value,
            ctaValue:
              adForm.value.ctaType === CTA_TYPES.url
                ? `https://${adForm.value.ctaValue}`
                : adForm.value.ctaValue,
          });
        }

        // Add the new fields to all advertisements
        if (adForm.value.startDate && adForm.value.startTime) {
          const startDateTime = new Date(
            `${adForm.value.startDate}T${adForm.value.startTime}`
          );
          payload.advertisement.startAt = startDateTime.toISOString();
        }
        if (adForm.value.endDate && adForm.value.endTime) {
          const endDateTime = new Date(
            `${adForm.value.endDate}T${adForm.value.endTime}`
          );
          payload.advertisement.endAt = endDateTime.toISOString();
        }
        payload.advertisement.isDefault = adForm.value.isDefault;

        await ctx.root.$store.dispatch("ads/createAd", payload);
        successNotification("Ad created successfully");
        ctx.root.$router.push("/advertisements/list");
      } catch (error) {
        const errMsg = error?.response?.data?.error?.message || 'An error occured'
        errorNotification(errMsg);
      } finally {
        submitting.value = false;
      }
    };

    return {
      submitForm,
      submitting,
      ctaTypes,
      SCREEN_TYPES,
      CTA_TYPES,
      screenOptions,
      screenType,
      adForm,
      today,
    };
  },
};
</script>
